// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ChevronDoubleRightIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronDoubleRight/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m13 5 7 7-7 7M5 5l7 7-7 7"
}));
export default ChevronDoubleRightIcon;